module.exports = __webpack_public_path__ + "h5/img/seach.26ca8fb0.png";